import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content, GroupField } from '@prismicio/client';
import useSWR from 'swr';
import { Simplify } from '@/prismicio-types';
import { ROUTES } from '@/routes';
import { CRYPTO_CHANGES_KEY } from './consts';
import { CryptoChangeResponse } from './types';
export const useCryptoChanges = coins => {
  const $ = _c(7);
  let coinNames;
  let t0;
  let t1;
  if ($[0] !== coins) {
    coinNames = coins.map(_temp).filter(Boolean);
    const shouldFetch = coinNames.length > 0;
    t0 = useSWR;
    t1 = shouldFetch ? [CRYPTO_CHANGES_KEY, ...coinNames] : null;
    $[0] = coins;
    $[1] = coinNames;
    $[2] = t0;
    $[3] = t1;
  } else {
    coinNames = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== coinNames) {
    t2 = async () => {
      const coinNamesString = coinNames.join(",");
      const url = ROUTES.APICryptoChanges(coinNamesString);
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch crypto changes");
      }
      return response.json();
    };
    $[4] = coinNames;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      revalidateOnMount: true,
      errorRetryCount: 3
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t0(t1, t2, t3);
};
function _temp(coin) {
  return coin.name || "";
}